import usersApi from './users.api';
import {User} from './users.types';
import {useCallback, useEffect, useState} from 'react';
import useAuth from '../auth/hooks/useAuth';
import {users} from '@cl/shared';
import {handleApiError} from '../errorHandling/handleApiError';
import routingService from '../routing/routing.service';
import {Routes} from '../routing/routing.config';
import {isPublicPage} from 'common/src/utils/urlUtils/isPublicPage';

const {userSubject} = users;

const updateUserSubject = (newUser: User) => {
  userSubject.data = newUser;
};

function useUser() {
  const [user, setUser] = useState(userSubject.data);
  const [error, setError] = useState<string>();

  const {isLoggedIn, clientId, setClientId} = useAuth();

  const getUser = useCallback(
    (refreshUser?: boolean) => {
      if (!isLoggedIn) return;

      usersApi
        .get(refreshUser)
        .then((newUser) => {
          updateUserSubject(newUser);
          setError(null);

          if (
            !!newUser &&
            !newUser.userClients[clientId] &&
            !isPublicPage(window.location.pathname)
          ) {
            setClientId(clientId);
            routingService.goTo(Routes.NoPermissions);
          }
        })
        .catch((e) => {
          handleApiError(e);
          setError(e.message);
        });
    },
    [clientId, isLoggedIn, setClientId],
  );

  useEffect(
    function loadUser() {
      const subscriptionId = userSubject.subscribe(setUser);

      getUser();

      return () => userSubject.unsubscribe(subscriptionId);
    },
    [getUser, setUser],
  );

  const refetchUser = useCallback(() => {
    getUser(true);
  }, [getUser]);

  return {user, isFromPublicProfile: !isLoggedIn, refetchUser, error};
}

export default useUser;
